import { AgentLanguage } from '../../../../components/agent-language'

export type LibraryAgentLanguageKey =
  | 'DOTNET'
  | 'NODE'
  | 'PYTHON'
  | 'PHP'
  | 'RUBY'
  | 'JAVA'
  | 'PROXY'
  | 'GO'

export type LibraryAgentLanguageValue =
  | '.NET'
  | 'Node'
  | 'Python'
  | 'PHP'
  | 'Ruby'
  | 'Java'
  | 'Proxy'
  | 'Go'

export class LibraryAgentLanguage {
  public static readonly DOTNET = new LibraryAgentLanguage('DOTNET', '.NET')
  public static readonly NODE = new LibraryAgentLanguage('NODE', 'Node')
  public static readonly PYTHON = new LibraryAgentLanguage('PYTHON', 'Python')
  public static readonly PHP = new LibraryAgentLanguage('PHP', 'PHP')
  public static readonly RUBY = new LibraryAgentLanguage('RUBY', 'Ruby')
  public static readonly JAVA = new LibraryAgentLanguage('JAVA', 'Java')
  public static readonly PROXY = new LibraryAgentLanguage('PROXY', 'Proxy')
  public static readonly GO = new LibraryAgentLanguage('GO', 'Go')

  public static getAsArray = () => [
    LibraryAgentLanguage.JAVA,
    LibraryAgentLanguage.DOTNET,
    LibraryAgentLanguage.NODE,
    LibraryAgentLanguage.PYTHON,
    LibraryAgentLanguage.PHP,
    LibraryAgentLanguage.PROXY,
    LibraryAgentLanguage.RUBY,
    LibraryAgentLanguage.GO
  ]

  public static fromValue = (value: LibraryAgentLanguageValue) => {
    switch (value) {
      case 'Java':
        return LibraryAgentLanguage.JAVA
      case 'Ruby':
        return LibraryAgentLanguage.RUBY
      case 'Python':
        return LibraryAgentLanguage.PYTHON
      case 'PHP':
        return LibraryAgentLanguage.PHP
      case 'Node':
        return LibraryAgentLanguage.NODE
      case '.NET':
        return LibraryAgentLanguage.DOTNET
      case 'Proxy':
        return LibraryAgentLanguage.PROXY
      case 'Go':
        return LibraryAgentLanguage.GO
      default:
        throw new Error(
          `Unexpected LibraryAgentLanguage value specified in fromValue: ${value}`
        )
    }
  }
  public static fromAgentLanguage = (agentLanguage: AgentLanguage) => {
    switch (agentLanguage) {
      case AgentLanguage.JAVA:
        return LibraryAgentLanguage.JAVA
      case AgentLanguage.RUBY:
        return LibraryAgentLanguage.RUBY
      case AgentLanguage.PYTHON:
        return LibraryAgentLanguage.PYTHON
      case AgentLanguage.PHP:
        return LibraryAgentLanguage.PHP
      case AgentLanguage.NODE:
        return LibraryAgentLanguage.NODE
      case AgentLanguage.DOTNET:
      case AgentLanguage.DOTNET_CORE:
        return LibraryAgentLanguage.DOTNET
      case AgentLanguage.PROXY:
        return LibraryAgentLanguage.PROXY
      case AgentLanguage.GO:
        return LibraryAgentLanguage.GO
      default:
        throw new Error(
          `Unexpected AgentLanguage specified in fromAgentLanguage: ${agentLanguage}`
        )
    }
  }

  public static fromLibraryAgentLanguage = (
    libraryAgentLanguage: LibraryAgentLanguage
  ) => {
    switch (libraryAgentLanguage) {
      case LibraryAgentLanguage.JAVA:
        return AgentLanguage.JAVA
      case LibraryAgentLanguage.DOTNET:
        return AgentLanguage.DOTNET
      case LibraryAgentLanguage.NODE:
        return AgentLanguage.NODE
      case LibraryAgentLanguage.RUBY:
        return AgentLanguage.RUBY
      case LibraryAgentLanguage.PYTHON:
        return AgentLanguage.PYTHON
      case LibraryAgentLanguage.PHP:
        return AgentLanguage.PHP
      case LibraryAgentLanguage.PROXY:
        return AgentLanguage.PROXY
      case LibraryAgentLanguage.GO:
        return AgentLanguage.GO
      default:
        throw new Error(
          `Unexpected library agent language: ${libraryAgentLanguage}`
        )
    }
  }
  private constructor(
    private key: LibraryAgentLanguageKey,
    private value: LibraryAgentLanguageValue
  ) {}
  public toString = () => `LibraryAgentLanguage.${this.key}`
  public getName = () => this.key
  public getValue = () => this.value
}
